import { axiosInstance, type CustomResponseFormat } from "api/instance";
import { ProgramType } from "data/programData";

export const RETROSPECT_DOMAIN = "retrospect";
export const RETROSPECT_LOAD_ENDPOINT = "data/load";

export interface RetrospectLoadedDataType {
  data: ProgramType;
}

export const retrospectApi = {
  load: (weekNumber: number, pid: number) =>
    axiosInstance.get<CustomResponseFormat<RetrospectLoadedDataType>>(
      `${RETROSPECT_DOMAIN}/${RETROSPECT_LOAD_ENDPOINT}`,
      { params: { week_number: weekNumber, pid } }
    ),
};
